import { useCallback, useMemo, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { utils } from '../../utils/utils';

const initialFilters = {
    pageSize: 10,
    pageNumber: 1
}

const useQueryString = (defaultFilters = initialFilters) => {
    const { search, pathname } = useLocation();
    const navigate = useNavigate();

    const searchParams = useMemo(() => new URLSearchParams(search), [search]);

    const filters = useMemo(() =>
        utils.GetParameterQueryString(searchParams)
        , [searchParams])

    const setFilters = useCallback((newState) => {
        const filters = utils.GetParameterQueryString(searchParams);
        const state = newState && typeof (newState) === 'function'
            ? newState(utils.NonEmptyOrNull(filters))
            : utils.NonEmptyOrNull({ ...filters, ...newState });

        const queryString = utils.GetQueryStringsFromObject(state);
        navigate(`${pathname}?${queryString}`);

        return state;
    }, [pathname, searchParams, navigate])

    useEffect(() => {
        setFilters(defaultFilters);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const GetQueryString = useCallback(() =>
        utils.GetParameterQueryString(new URLSearchParams(search))
        , [search])

    const clearFilters = useCallback(() =>
        navigate(`${pathname}`)
    , [pathname, navigate]);

    return {
        filters,
        search,
        setParameterSearch: setFilters,
        GetQueryString,
        clearFilters
    }
}

export default useQueryString